import { useContext } from 'react';
import { TouchGestureContext } from './touch-gesture-context';

export function useTouchGestures() {
  const context = useContext(TouchGestureContext);
  if (!context) {
    throw new Error('useTouchGestures must be used within a TouchGestureProvider');
  }
  return context;
}
